import { CopyText } from "@/libraries/design/components/copy-text/src/copy-text";

export interface UniformCopyTextProps {
    /** The text content to be copied to clipboard */
    text: string;
    /** The label for the copy button */
    buttonText?: string;
    /** The text shown on the button after a successful copy */
    copiedText?: string;
    /** The aria-label applied to the button after a successful copy */
    copiedAriaLabel?: string;
}

const UniformCopyText = ({
    text,
    buttonText,
    copiedText,
    copiedAriaLabel
}: UniformCopyTextProps) => {
    return (
        <CopyText
            text={text}
            buttonText={buttonText}
            copiedText={copiedText}
            copiedAriaLabel={copiedAriaLabel}
        />
    );
};

export default UniformCopyText;
